import React from 'react'
import styled from 'styled-components';
import screenshot1 from '../../assets/img/screenshot.png';

const ScreenshotsRoot = styled.div`
    display: flex;  
    justify-content: center;  
    flex-flow: column;
    margin: 0 7em;
    @media (max-width: 768px) {
        margin: 0;
    }
`;

const Screenshot = styled.img`
    border-radius: 5em;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Video = styled.iframe`
    margin: 0em auto 4em auto;
    border: solid 2px var(--main-color);
    width: 840px;
    height: 472px;
    @media (max-width: 840px) {
        width: 99%;
    }
`;

const Screenshots = () => {
    return (
        <ScreenshotsRoot>
            <Video src="https://www.youtube.com/embed/me4FiIoOkIQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></Video>
            <Screenshot src={screenshot1} />
        </ScreenshotsRoot>
    )
};

export default Screenshots;


// WEBPACK FOOTER //
// ./src/pages/Screenshots/Screenshots.jsx